import api from "./axios";
import { DashboardHome } from "../interfaces/Dashboard";

// O baseURL do axios já inclui /api.
const BASE = "/Dashboard";

const toIsoDate = (d?: Date | string | null) => {
  if (!d) return undefined;
  const date = typeof d === "string" ? new Date(d) : d;
  return date.toISOString().slice(0, 10);
};

/**
 * Toda a home em uma chamada. Os blocos que o papel do usuário não pode ver vêm `null`.
 */
export async function getHome(
  month?: number,
  year?: number,
  week?: Date | string
): Promise<DashboardHome> {
  const { data } = await api.get<DashboardHome>(`${BASE}/home`, {
    params: { month, year, week: toIsoDate(week) },
  });
  return data;
}
